const Home = () => import('@/views/Home/home')
/**
 * hidden: true                   是否显示在侧栏上
 * meta : {
    title: 'title'               设置侧栏名字
    icon: 'svg-name'             侧栏icon图片名,
    showSubiems: ‘false’         侧栏的展开状态
    sort: 1,                     侧栏排序
    active: []                   业务逻辑的子页面高亮设置
    nocache: true                组件将不keep-alive
  }
 **/

export const UserCenterRouteMap = {
  UserCenter: 'user-center',
  UserManagement: 'user',
  AgencyManagement: 'agency-management',
}

const UserCenter = [
  {
    path: '/user',
    name: UserCenterRouteMap.UserManagement,
    component: Home,
    meta: {
      title: '用户管理',
      icon: 'icon-user',
      showSubiems: false,
      sort: 4,
      permission: 'user:root',
      modules: 'user',
    },
    children: [],
  },
  {
    path: '/user',
    name: UserCenterRouteMap.AgencyManagement,
    component: Home,
    meta: {
      title: '代理管理',
      icon: 'icon-user',
      showSubiems: false,
      sort: 4,
      permission: 'proxy',
      modules: 'user',
    },
    children: [],
  },
]

export default UserCenter
